import { compose, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { nullFunc } from '../../../utils/helpers';
import { getBrandId } from '../../../brands/selectors';
import { getPixelForOwner } from '../fbPixel/ownerPixels';
import WithShop from '../../../hoc/WithShop';
import FBPixel from '../fbPixel';
import withConsent from '../fbPixel/withConsent';

export default compose(
  withRouter,
  connect((state, props) => ({
    brandId: getBrandId(state, props.params.brandRoute),
  })),
  WithShop,
  withConsent,
  withPropsOnChange(
    ['shop', 'brandId'],
    (props) => {
      const brandId = props.shop ? props.shop.brandId : props.brandId;
      let pixel = getPixelForOwner('brand', brandId);
      if (!pixel && props.shop) {
        pixel = getPixelForOwner('shop', props.shop.id);
      }

      if (pixel) {
        FBPixel.init();
        FBPixel.setPixelFor('ownerPixel', pixel);
        FBPixel.trackPageView('ownerPixel');
        return;
      }

      FBPixel.setPixelFor('ownerPixel', null);
    }
  )
)(nullFunc);



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/containers/FbPixel.js